<template>
  <div class="content-area__heading">
    <top-nav>
      <div slot="title">
        <h2>Clientes</h2>
      </div>
      <div>
        <i-input clearable suffix="ios-search" v-model="search"></i-input>
      </div>
    </top-nav>
    <vx-table :data="data" :columns="columns" :loading="loading" @sort="onSort" />
    <vx-drawer ref="drawer" :title="title" v-model="show_edit">
      <div v-if="show_edit">
        <Spin size="large" fix v-if="loading_save"></Spin>
        <liberar v-if="action == 1" :data="form" :show_save="show_update" @change="onChange" @input="onSave" />
        <inutilizar-nota v-if="action == 3" :id_empresa="id_empresa" :show_save="show_update" @change="onChange"
          @input="onSave" />
        <alterar-fiscais v-if="action == 4" :data="form" :show_save="show_update" @change="onChange" @input="onSave" />
        <atualizar-dados v-if="action == 0" :data="form" :show_save="show_update" @change="onChange" @input="onSave" />
        <debug v-if="action == 2" :id_empresa="id_empresa" :show_save="show_update" @change="onChange"
          @input="onSave" />
        <notas-pendentes v-if="action == 5" :id_empresa="id_empresa" :show_save="show_update" @change="onChange"
          @input="onSave" />
        <upload-certificado v-if="action === 6" :id_empresa="id_empresa" />
        <integrar-napp v-if="action === 7" :id_empresa="id_empresa" />
        <gerenciar-canais-de-venda v-if="action === 8" :id_empresa="id_empresa" />
      </div>
    </vx-drawer>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import { moment } from "../../helpers/utils";
import { revendaApi } from "@/api/axios";

export default {
  components: {
    TopNav: () => import("../../components/nav-bar/top-nav"),
    Liberar: () => import("./components/Liberar"),
    InutilizarNota: () => import("./components/InutilizarNota"),
    AlterarFiscais: () => import("./components/AlterarFiscais"),
    AtualizarDados: () => import("./components/AtualizarDados"),
    Debug: () => import("./components/Debug"),
    NotasPendentes: () => import("./components/NotasPendentes"),
    UploadCertificado: () => import("./components/UploadCertificado"),
    IntegrarNapp: () => import("./components/IntegrarNapp"),
    GerenciarCanaisDeVenda: () => import("./components/GerenciarCanaisDeVenda"),
  },
  data: () => ({
    search: "",
    loading: false,
    loading_save: false,
    show_edit: false,
    title: "",
    form: [],
    show_update: false,
    id_empresa: 0,
    options: [
      {
        icone: "ios-undo",
        label: "Alterar data de ativação",
        textColor: "#ff9900",
        show: true,
      },
      {
        icone: "md-cloud-upload",
        label: "Upload Certificado Digital",
        textColor: "#428bca",
        show: true,
      },
      {
        icone: "md-bug",
        label: "Modo Debug",
        textColor: "#ff5252",
        show: true,
      },
      {
        icone: "md-trash",
        label: "Zerar estoque de todos os produtos",
        textColor: "#800000",
        show: true,
      },
      {
        icone: "md-checkmark",
        label: "Habilitar empresa na eNotas",
        textColor: "#00bfa5",
        show: true,
      },
      {
        icone: "md-close",
        label: "Desabilitar empresa na eNotas",
        textColor: "#ff5252",
        show: true,
      },
      {
        icone: "md-document",
        label: "Inutilizar Nota(s)",
        textColor: "#ff5252",
        show: true,
      },
      {
        icone: "md-document",
        label: "Gerar nota em contingência",
        textColor: "#00bfa5",
        show: true,
      },
      {
        icone: "md-document",
        label: "Notas Pendentes",
        textColor: "#ff5252",
        show: true,
      },
      {
        icone: "md-document",
        label: "Envia NFC-e em Contigência",
        textColor: "#00bfa5",
        show: false,
      },
      {
        icone: "md-document",
        label: "Alterar Fiscais",
        textColor: "#00bcd4",
        show: false,
      },
      {
        icone: "md-document",
        label: "Corrigir fiscal dados dos movimentos",
        textColor: "#ceca31",
        show: false,
      },
      {
        icone: "md-send",
        label: "Reenviar e-mail",
        textColor: "#004080",
        show: false,
      },
    ],
    action: null,
    pagination: {
      page: 1,
      last_page: false,
    },
    data: [],
    columns: [],
  }),
  computed: {
    ...mapGetters(["currentUser"]),
  },
  methods: {
    permission() {
      const permission = this.currentUser.permissao.filter((item) => {
        if (item.label === "Desenvolvimento" && item.value === "Clientes") {
          return item;
        }
      });
      return permission.length > 0;
    },

    userIsGeneralManager() {
      return this.currentUser.usuario_cargo === 1; // 1 = Gerente Geral
    },

    userIsSupport() {
      return [10, 11, 12].includes(this.currentUser.usuario_cargo); // 10,11,12 = Suporte
    },

    userIsGeneralManagerOrSupport() {
      return this.userIsGeneralManager() || this.userIsSupport();
    },

    canSeeNapp() {
      if (process.env.NODE_ENV === 'development') {
        return [1, 2].includes(this.currentUser.usuario_cargo);
      }

      return this.userIsGeneralManagerOrSupport();
    },

    canSeeEcommerceSaleChannels() {
      if (process.env.NODE_ENV === 'development') {
        return [1, 2].includes(this.currentUser.usuario_cargo);
      }

      return this.userIsGeneralManagerOrSupport();
    },

    /**
     * Responsável carregar os dados
     */
    async getData(key = null, order = null) {
      this.loading = true;
      try {
        const URI = `/clientes/all`;
        const { data } = await this.$axios.get(URI, {
          params: {
            page: this.pagination.page,
            search: this.search,
            key: key,
            order: order,
          },
        });

        if (!data.companies.error) {
          if (data.companies.current_page === 1) {
            this.data = data.companies.data;
          } else {
            this.data = this.data.concat(data.companies.data);
          }
          if (data.last_page == data.current_page) {
            this.pagination.last_page = true;
          }
          this.pagination.current_page = data.companies.current_page;
          this.pagination.last_page = data.companies.last_page;
        }
      } catch (error) {
        console.warn(error);
      }
      this.loading = false;
    },
    /**
     * Responsável montar a estrutura da tabela
     */
    getColumns() {
      // exemplo de um item para coluna no componente vx-table
      // {
      //         label: "Nome", //nome da coluna
      //         key: "pessoa_nome", //chave de controle
      //         order:'asc', // orientação da ordenação inicial
      //         sortable:true, // ativar ordenação
      //         filters: [ // filtros list
      //             {
      //                 label: "Todos",
      //                 value: 0
      //             },
      //             {
      //                 label: "Mop-Up Soluções Em Limpeza",
      //                 value: 68
      //             },
      //             {
      //                 label: "Bio Flora",
      //                 value: 79
      //             },
      //         ],
      //         filterMethod:"id_pessoa" // campo a qual o filtro deve ser igual
      //     },
      this.columns.push(
        {
          label: "Código ",
          key: "id_pessoa",
          order: "asc",
          sortable: true,
        },
        {
          label: "Nome",
          key: "nome",
          order: "asc",
          sortable: true,
          render: (h, params) => {
            return h("h4", [h("p", [`${params.row.nome}`])]);
          },
        },
        {
          label: "CNPJ",
          key: "cnpj",
          order: "asc",
          sortable: true,
          render: (h, params) => {
            return h("h4", [
              h(
                "p",
                {
                  style: {
                    whiteSpace: "nowrap",
                  },
                },
                [`${params.row.cnpj}`]
              ),
            ]);
          }
        },
        {
          label: "VENDEDOR",
          key: "nome_vendedor",
          order: "asc",
          sortable: true,
          render: (h, params) => {
            return h("h4", [
              h(
                "p",
                {
                  style: {
                    whiteSpace: "nowrap",
                  },
                },
                [`${params.row.nome_vendedor ? params.row.nome_vendedor : ''}`]
              ),
            ]);
          }
        },
        {
          label: "Plano",
          key: "id_plano",
          order: "asc",
          sortable: true,
          render: (h, params) => {
            let plans = {
              4992: "Só Emissor de Notas",
              6556: "MEI",
              6557: "Gestão Básica",
              5060: "Notas & PDV",
              6558: "Gestão Completa",
              6554: "Trial",
              11: "Ilimitado",
            };
            let plano = plans["11"];
            if (plans[params.row.id_plano]) plano = plans[params.row.id_plano];

            return h("h4", [h("p", [`${plano}`])]);
          },
        },
        {
          label: "Recorrencia",
          key: "recorrencia",
          order: "asc",
          sortable: true,
          render: (h, params) => {
            let recurrency = "";
            if (params.row.recorrencia) recurrency = params.row.recorrencia;

            return h("h4", [h("p", [`${recurrency}`])]);
          },
        },
        {
          label: "Valor",
          key: "valor_plano",
          order: "asc",
          sortable: true,
          render: (h, params) => {
            let valor = "";
            if (params.row.valor_plano)
              valor = new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              }).format(params.row.valor_plano);

            return h("h4", [h("p", [`${valor}`])]);
          },
        },
        {
          label: "Telefone",
          key: "telefone",
          order: "asc",
          sortable: true,
          render: (h, params) => {
            let phone = "";
            let mobile = "";
            if (params.row.telefone) {
              phone = params.row.telefone.split(",", 1);
            }
            if (params.row.celular) {
              mobile = params.row.celular.split(",", 1);
            }
            return h("div", [
              h("span", `${phone}`),
              h("br"),
              h("span", `${mobile}`),
            ]);
          },
        },
        {
          label: "status",
          key: "enotas",
          order: "asc",
          sortable: true,
          render: (h, params) => {
            const enotasContent = params.row.enotas_empresa_id
              ? params.row.emissao_nfse
                ? "Enotas Habilitado"
                : "Enotas Desabilitado"
              : "Sem cadastro";
            const radiocClass = params.row.enotas_empresa_id
              ? params.row.emissao_nfse
                ? "circle-radio-enable-enotas"
                : "circle-radio-disable-enotas"
              : "circle-radio-off-enotas";

            const certStatus = this.getCertificadoStatus(params.row.certificado_digital_data_vencimento);

            return h("div", {
              style: {
                display: "flex",
                alignItems: "center",
                marginLeft: "20px",
              },
            }, [
              h(
                "Tooltip",
                {
                  props: {
                    placement: "top",
                    content: enotasContent,
                  },
                },
                [
                  h("div", {
                    attrs: {
                      class: radiocClass,
                    },
                  }),
                ]
              ),
              certStatus ? h(
                "Tooltip",
                {
                  style: {
                    marginLeft: "8px",
                  },
                  props: {
                    placement: "top",
                    content: certStatus.message,
                  },
                },
                [
                  h("div", {
                    style: {
                      width: "12px",
                      height: "12px",
                      borderRadius: "50%",
                      backgroundColor: certStatus.color,
                      display: "inline-block",
                      border: certStatus.status === "expired" || certStatus.status === "warning" ? "2px solid " + certStatus.color : "none",
                      boxShadow: certStatus.status === "expired" || certStatus.status === "warning" ? "0 0 4px " + certStatus.color : "none",
                    },
                  }),
                ]
              ) : null
            ]);
          },
        },
        {
          label: " ",
          key: "options",
          render: (h, params) => {
            const enable = params.row.enotas_empresa_id
              ? !params.row.emissao_nfse
              : false;
            const disable = params.row.enotas_empresa_id
              ? !!params.row.emissao_nfse
              : false;

            const options = JSON.parse(JSON.stringify(this.options));
            options.find(
              (option) => option.label === "Habilitar empresa na eNotas"
            ).show = enable;
            options.find(
              (option) => option.label === "Desabilitar empresa na eNotas"
            ).show = disable;

            return h("VxOptions", {
              attrs: {
                id: params.row.id_pessoa,
                onSelect: this.option,
                options,
              },
            });
          },
        }
      );
    },
    /**
     * Responsável abrir o registro para edição
     */
    onUpdate(id) {
      this.form = this.data.filter((item) => {
        return item.id_pessoa == id;
      });
      this.action = 0;
      this.title = `${id} - ${this.form[0].nome}`;
      this.show_edit = true;
    },
    /**
     * Responsável por selecionar função adequada para a ação tomada pelo usuário
     */
    async option(id, label, key) {
      if (label === "Modo Debug") {
        this.action = 2;
        this.show_edit = true;

        this.loading_save = true;
        this.loading_save = false;
        this.id_empresa = id;
      } else if (label === "Notas Pendentes") {
        this.action = 5;
        this.show_edit = true;
        this.id_empresa = id;
      } else if (label === "Upload Certificado Digital") {
        this.form = this.data.filter((item) => item.id_pessoa == id);
        this.action = 6;
        this.title = `${id} - ${this.form[0].nome} - ${label}`;
        this.show_edit = true;
        this.id_empresa = id;
      } else if (label === "Alterar data de ativação") {
        this.form = this.data.filter((item) => {
          return item.id_pessoa == id;
        });

        await this.getStatsData(this.form[0]);
        this.show_edit = true;

        this.loading_save = true;

        this.action = 1;
        this.title = `${id} - ${this.form[0].nome}`;

        this.loading_save = false;
      } else if (label === "Inutilizar Nota(s)") {
        this.action = 3;
        this.show_edit = true;

        this.loading_save = true;
        this.loading_save = false;
        this.id_empresa = id;
      } else if (label === "Zerar estoque de todos os produtos") {
        this.$Modal.confirm({
          title: "Zerar estoque de todos produtos?",
          content: "Esta ação não pode ser desfeita.",
          cancelText: "Não",
          okText: "Sim",
          onOk: () => {
            this.loading = true;
            this.loading_save = true;
            this.zerarEstoque(id);
          },
        });
      } else if (label === "Habilitar empresa na eNotas") {
        this.$Modal.confirm({
          title: "Habilitar empresa",
          content: "Tem certeza que deseja habilitar a empresa na eNotas?",
          cancelText: "Não",
          okText: "Sim",
          onOk: () => {
            this.loading = true;
            this.loading_save = true;
            this.enableOrDisableEnotas(id, true);
          },
        });
      } else if (label === "Desabilitar empresa na eNotas") {
        this.$Modal.confirm({
          title: "Desabilitar empresa",
          content: "Tem certeza que deseja desabilitar a empresa na eNotas?",
          cancelText: "Não",
          okText: "Sim",
          onOk: () => {
            this.loading = true;
            this.loading_save = true;
            this.enableOrDisableEnotas(id, false);
          },
        });
      } else if (label === "Integrar Napp Solutions") {
        this.form = this.data.filter((item) => item.id_pessoa == id);
        this.action = 7;
        this.title = `${id} - ${this.form[0].nome} - ${label}`;
        this.show_edit = true;
        this.id_empresa = id;
      } else if (label === "Gerenciar Canais de Venda") {
        this.form = this.data.filter((item) => item.id_pessoa == id);
        this.action = 8;
        this.title = `${id} - ${this.form[0].nome} - ${label}`;
        this.show_edit = true;
        this.id_empresa = id;
      } else {
        this.$Modal.confirm({
          title: "Gerar nota em contigência?",
          content: "Esta ação não pode ser desfeita.",
          cancelText: "Não",
          okText: "Sim",
          onOk: () => {
            this.loading = true;
            this.loading_save = true;
            this.notaContigencia(id);
          },
        });
      }
    },
    /**
     * Responsável por zerar o estoque de todos os produtos no Bitis
     */
    async zerarEstoque(id) {
      this.$Message.warning({
        content: "Zerando estoque. Isso pode demorar alguns segundos. Aguarde...",
        duration: 5,
      });
      const data = await this.$axios.post("clientes/resetStock", {
        id_empresa: id,
      });

      const response = data.data;

      if (response["result"] == "success") {
        this.loading = false;
        this.$Message.success("Estoque zerado com sucesso!");
      } else {
        this.loading = false;
        this.$Message.error("Oops, aconteceu um erro. Tente novamente.");
      }
    },
    /**
     * Responsável por habilitar/desabilitar a empresa na enotas
     */
    async enableOrDisableEnotas(id_empresa, enable) {
      try {
        const { data } = await this.$axios.post(
          "clientes/enableOrDisableEnotas",
          {
            id_empresa,
            enable,
          }
        );

        if (data.codigo === 1) {
          this.$Message.success(data.mensagem);
          this.data.find(
            (value) => value.id_pessoa === id_empresa
          ).emissao_nfse = enable;
        } else {
          this.$Message.error(
            data.mensagem || "Oops, aconteceu um erro. Tente novamente."
          );
        }
      } catch (error) {
        console.warn(error);
        this.$Message.error("Oops, aconteceu um erro. Tente novamente.");
      } finally {
        this.loading = false;
      }
    },
    async notaContigencia(id) {
      this.$Message.warning({
        content:
          "Gerando nota em contigência. Isso pode demorar alguns segundos. Aguarde ...",
        duration: 5,
      });
      try {
        const { data } = await this.$axios.post("clientes/contigency", {
          id_empresa: id,
        });
        this.loading = false;
        this.$Message.success(data.response.xMotivo);
      } catch (error) {
        this.loading = false;
        this.$Message.error({
          content: error.message,
          duration: 4,
        });
      }
    },
    /**
     * Responsável por salvar as alterações
     */
    onSave(form) {
      let currentUserEmail = JSON.parse(localStorage.vuex).currentUser.email;
      let date = moment(form.period).format("YYYY-MM-DD");
      this.loading_save = true;
      this.show_update = false;
      this.updateDateActiveSystem(date, currentUserEmail);
      this.loading_save = false;
      this.show_edit = false;
    },
    /**
     * Responsável por capturar alterações nos formularios
     */
    onChange() {
      this.show_update = true;
    },
    /**
     * Responsável pela confirmação da ação
     */
    onConfirm(title, key, id) {
      return new Promise((resolve) => {
        this.$Modal.confirm({
          title: title,
          cancelText: "Não",
          okText: "Sim",
          onOk: () => {
            // reenviar e-mail
            if (key == 7) {
              this.sendEmail(id);
            }
            resolve();
          },
        });
      });
    },

    /**
     * Responsável por enviar o e-mail para o cliente
     */
    async sendEmail(id_compay) {
      const { data } = await revendaApi.post('/company/email', { id_company: id_compay, type: "owner" });

      data.status
        ? this.$vs.notify({
          title: "Sucesso",
          text: data.message,
          color: "success",
        })
        : this.$vs.notify({
          title: "Erro",
          text: data.message,
          color: "danger",
        });
    },

    async updateDateActiveSystem(date, email) {
      let response = await this.$axios.post("clientes/update/activeSystem", {
        date: date,
        company_id: this.form[0].id_pessoa,
        email: email,
      });
      response.data.code === 1
        ? this.$vs.notify({
          title: "Sucesso",
          text: response.data.message,
          color: "success",
        })
        : this.$vs.notify({
          title: "Erro",
          text: response.data.message,
          color: "danger",
        });
    },

    onSort() {
      this.getData();
    },
    /**
     * Responsável pela paginação dos registros quando alcança o fim da página
     */
    handleScroll: _.debounce(function (e) {
      const el = e.target.documentElement || e.target;
      let windowRelativeBottom = el.scrollHeight - el.offsetHeight;
      if (
        el.scrollTop > windowRelativeBottom - 50 &&
        this.pagination.current_page < this.pagination.last_page
      ) {
        this.pagination.page++;
        this.getData();
        el.scrollTop = windowRelativeBottom;
      }
    }, 1000),
    async getStatsData(data) {
      this.loading_save = true;

      let response = await this.$axios.get("clientes/stats", {
        params: {
          id: data.id_pessoa,
        },
      });

      if (response.data.stats !== 0) {
        this.form.push(response.data[0]);
      }

      this.loading_save = false;
    },
    /**
     * Responsável por verificar o status do certificado digital
     * Retorna: null se não houver data, ou objeto com status, message e color
     */
    getCertificadoStatus(dataVencimento) {
      if (!dataVencimento) {
        return null;
      }

      const expirationDate = moment(dataVencimento);
      const today = moment();
      const daysUntilExpiration = expirationDate.diff(today, 'days');

      if (daysUntilExpiration < 0) {
        // Certificado vencido
        return {
          status: "expired",
          message: `Certificado vencido em ${expirationDate.format("DD/MM/YYYY")}`,
          color: "#FF5252" // Vermelho
        };
      } else if (daysUntilExpiration <= 30) {
        // Certificado próximo do vencimento (30 dias ou menos)
        return {
          status: "warning",
          message: `Certificado vence em ${daysUntilExpiration} dia(s) - ${expirationDate.format("DD/MM/YYYY")}`,
          color: "#FF9900" // Laranja/Amarelo
        };
      } else {
        // Certificado válido
        return {
          status: "valid",
          message: `Certificado válido até ${expirationDate.format("DD/MM/YYYY")}`,
          color: "#28C76F" // Verde
        };
      }
    },
  },
  watch: {
    search: _.debounce(function (e) {
      this.pagination.page = 0;
      this.getData();
    }, 500),
  },
  created() {
    if (this.permission()) {
      this.options.push({
        icone: "md-bug",
        label: "Habilitar logs de Debug",
        textColor: "#000000",
      });
    }

    if (this.canSeeNapp()) {
      this.options.push({
        icone: "md-archive",
        label: "Integrar Napp Solutions",
        textColor: "#000000",
        show: true,
      })
    }

    if (this.canSeeEcommerceSaleChannels()) {
      this.options.push({
        icone: "md-cart",
        label: "Gerenciar Canais de Venda",
        textColor: "#00bad1",
        show: true,
      })
    }

    this.getColumns();
    this.getData();
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    let el = document.querySelector(".content-wrapper");
    if (el) {
      el.addEventListener("scroll", this.handleScroll);
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    let el = document.querySelector(".content-wrapper");
    if (el) {
      el.removeEventListener("scroll", this.handleScroll);
    }
  },
};
</script>
